import moment from "moment";

const readableDate = (date: Date) => {
  return moment(date).calendar({
    sameDay: "[Today]",
    nextDay: "[Tomorrow]",
    nextWeek: "dddd",
    lastDay: "[Yesterday]",
    lastWeek: "[Last] dddd",
    sameElse: "MM/DD/YYYY",
  });
};

export { readableDate };
